/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// handles saving the address data in signup logic
const extendSignupForm = () => {
    const signupForm = document.querySelector('form#create_customer--likor');
    if(!signupForm){
        return;
    }
    signupForm.addEventListener('submit',(event) => {
        const address1 = document.querySelector('[name="address[address1]"]').value;
        const zip = document.querySelector('[name="address[zip]"]').value;
        const city = document.querySelector('[name="address[city]"]').value;
        const country = document.querySelector('[name="address[country]"]').value;
        window.localStorage.setItem('address1', address1 );
        window.localStorage.setItem('address1-zip', zip );
        window.localStorage.setItem('address1-city', city );
        window.localStorage.setItem('address1-country', country );
    })

}
document.addEventListener("DOMContentLoaded", extendSignupForm);

(function(){
    const formElement = document.querySelector('#address_form_new');
    // if customer has address already then return > otherwise check for address saved in localstorage (custom.js) and submit
    if ( window.localStorage.getItem('address1') === null || !formElement) {
     return true;
    }
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    document.querySelector('#address_form_new [name="address[address1]"]').value = window.localStorage.getItem('address1');
    document.querySelector('#address_form_new [name="address[zip]"]').value = window.localStorage.getItem('address1-zip');
    document.querySelector('#address_form_new [name="address[city]"]').value = window.localStorage.getItem('address1-city');
    document.querySelector('#address_form_new [name="address[country]"]').value = window.localStorage.getItem('address1-country');



    fetch("/account/addresses", {
        body: JSON.stringify(window.serialize(formElement)),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

        }
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (response.ok) {
            // console.log("address is saved");
            window.localStorage.removeItem("address1");
            window.localStorage.removeItem("address1-zip");
            window.localStorage.removeItem("address1-city");
            window.localStorage.removeItem("address1-country");
        } else {
            console.log( 'Oops! Something went wrong.' );
        }
      });
  })();
